import classNames from 'classnames';
import React from 'react';

//
// Avatar
//

interface AvatarProps {
  as?: React.ElementType;
  ratio?: string;
  size?: string;
  status?: string;
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

const Avatar = React.forwardRef<HTMLElement, AvatarProps>(
  ({ as: Tag = 'div', ratio, size, status, className, ...props }, ref) => {
    const classes = classNames(
      'avatar',
      ratio && `avatar-${ratio}`,
      size && `avatar-${size}`,
      status && `avatar-${status}`,
      className
    );

    return <Tag className={classes} ref={ref} {...props} />;
  }
) as any;

Avatar.displayName = 'Avatar';

//
// Avatar group
//

Avatar.Group = React.forwardRef<HTMLElement, AvatarProps>(({ as: Tag = 'div', className, ...props }, ref) => {
  const classes = classNames('avatar-group', className);

  return <Tag className={classes} ref={ref} {...props} />;
});

Avatar.Group.displayName = 'Avatar.Group';

//
// Avatar image
//

interface AvatarImageProps {
  as?: React.ElementType;
  className?: string;
  src?: string;
  alt?: string;
  [key: string]: any;
}

Avatar.Image = React.forwardRef<HTMLElement, AvatarImageProps>(({ as: Tag = 'img', className, ...props }, ref) => {
  const classes = classNames('avatar-img', className);

  return <Tag className={classes} ref={ref} {...props} />;
});

Avatar.Image.displayName = 'Avatar.Image';

//
// Avatar title
//

Avatar.Title = React.forwardRef<HTMLElement, AvatarProps>(({ as: Tag = 'div', className, ...props }, ref) => {
  const classes = classNames('avatar-title', className);

  return <Tag className={classes} ref={ref} {...props} />;
});

Avatar.Title.displayName = 'Avatar.Title';

export default Avatar;
